import { render } from "./IdField.vue?vue&type=template&id=7fdba5f4"
import script from "./IdField.vue?vue&type=script&lang=js"
export * from "./IdField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IdField.vue"]])

export default __exports__